import VForm from './VForm';
export { VForm };
export default VForm;
//# sourceMappingURL=index.js.map